jQuery(document).ready(function ($) {
    if((window.location.pathname.match(/\//g) || []).length <= 4 ){
        $('.etheme_swatches_filter.size-or').remove();
        $('.etheme_swatches_filter.colour-or').remove();
    };
    $('.sidebar-widget').css('display', 'block');
});